<template>
  <div class="user-video-block" target="_blank" :class="{ empty: !src && !bg }" :style="style" @click="toggleVideo">
    <video ref="video" :src="src" class="video-preview" v-if="src"></video>
    <div class="play" v-if="src" :class="{ paused }"></div>
  </div>
</template>

<script>
export default {
  name: 'UserVideo',
  props: {
    src: {},
    bg: {},
  },
  data: () => ({
    paused: true,
  }),
  computed: {
    style() {
      if (this.bg && !this.src) {
        return {
          'background-image': `url(${this.bg})`,
        }
      }
      return {}
    },
  },
  methods: {
    toggleVideo() {
      const video = this.$refs.video
      if (video.paused) {
        this.paused = false
        video.play()
      } else {
        this.paused = true
        video.pause()
      }
    },
    load() {
      const video = this.$refs.video
      if (video) {
        video.load()
      }
    },
  },
  mounted() {
    this.load()
  },
  watch: {
    src() {
      this.load()
    },
  },
}
</script>

<style lang="scss">
.user-video-block {
  display: block;
  width: 100%;
  height: 196px;
  border-radius: 10px;
  background: $gray;
  background-size: cover;
  position: relative;
  overflow: hidden;
  cursor: pointer;

  &.empty {
    opacity: 0;
    pointer-events: none;

    @include mobile {
      display: none;
    }
  }

  .video-preview {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: 100%;
    height: 100%;
    object-fit: cover;
    background: $gray;
    margin: 0 auto;
  }

  .play {
    width: 55px;
    height: 55px;
    position: absolute;
    right: 12px;
    bottom: 12px;
    background: rgba($white, 0.5) url('~@/assets/icons/pause.svg') no-repeat center center;
    border-radius: 50%;
    border: 2px solid $white;

    &.paused {
      background-image: url('~@/assets/icons/play.svg');
    }
  }

  @include PC {
    height: 281px;
    border-radius: 10px;

    .play {
      width: 50px;
      height: 50px;
      right: 16px;
    }
  }
}
</style>
